import React from 'react'
import { Button } from 'antd'
import kurs_ishi from '../fayl/meyoriy_xujjatlar/kurs ishi.pdf'

export const Kurs_ishi = () => {
  return (
    <div>
        <Button className='button'>
            <a href={kurs_ishi}>Kurs ishi</a>
        </Button>
    </div>
  )
}
